export type SyncReprobeSource = 'online' | 'focus' | 'surface' | 'nav' | 'interaction'

export type SyncReprobeGateInput = {
  source: SyncReprobeSource
  logoutInProgress: boolean
  hasAuthSession: boolean
  isSyncAuth: boolean
  isVisible: boolean
  browserOnline: boolean
  isSyncOfflineLike: boolean
  inFlight: boolean
  now: number
  lastReprobeAt: number
  cooldownMs: number
  force?: boolean
}

export type SyncReprobeDecision<T> =
  | { shouldRun: false }
  | { shouldRun: true, mountedProfileRecovery: T | undefined }

export function resolveSyncReprobe<T>(
  input: SyncReprobeGateInput,
  resolveMountedProfileRecovery: () => T | undefined
): SyncReprobeDecision<T> {
  if (input.logoutInProgress) return { shouldRun: false }
  if (!input.hasAuthSession) return { shouldRun: false }
  if (!input.isVisible) return { shouldRun: false }
  if (!input.browserOnline) return { shouldRun: false }
  if (input.inFlight) return { shouldRun: false }
  if (
    input.force !== true
    && input.now - input.lastReprobeAt < input.cooldownMs
  ) {
    return { shouldRun: false }
  }

  // Interaction may retry ordinary reachability from runtime facts, but the
  // pointer and keyboard paths never inspect mounted Account identity.
  const mountedProfileRecovery = input.source === 'interaction'
    ? undefined
    : resolveMountedProfileRecovery()
  if (!input.isSyncAuth && !mountedProfileRecovery) return { shouldRun: false }
  if (!input.isSyncOfflineLike && !mountedProfileRecovery) return { shouldRun: false }
  return { shouldRun: true, mountedProfileRecovery }
}
